module.exports = __webpack_public_path__ + "static/media/new_business_image.894f2ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/new_business_image.png
// module id = 494
// module chunks = 0